import { useEffect } from 'react';

import { Keys } from '@components/types/keyboard';

type UseKeyPress = {
  enabled?: boolean;
  key: Keys;
  handler: (event: DocumentEventMap['keydown']) => void;
};

export const useKeyPress = ({ key, enabled = true, handler: userHandler }: UseKeyPress) => {
  useEffect(() => {
    if (!enabled) return;

    const handler = (event: KeyboardEvent) => {
      if (event.key !== key) return;
      userHandler(event);
    };

    document.addEventListener('keydown', handler);

    return () => {
      document.removeEventListener('keydown', handler);
    };
  }, [key, enabled, userHandler]);
};
